import { Component, OnInit, Signal } from "@angular/core";
import * as FileSaver from "file-saver";
import { Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { debounceTime, EMPTY, Subject, switchMap } from "rxjs";
import { QuoteNotesGridService } from "../../../../core/services/quote-notes-grid.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { GetQuotesDto } from "../../../../core/models/qoutes/getQuotesDto";
import { QuotesNotesDto } from "../../../../core/models/qoutes/quotesNotesDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { SharedService } from "../../../../core/services/shared.service";
import { SidebarService } from "../../../../core/services/sidebar.service";
import { QuoteStatus } from "../../../../shared/enums/QuotesStatus";
import { TableFilterEvent, TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { QuoteSummaryComponent } from "../quote-summary/quote-summary.component";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { QuoteNotesGridComponent } from "../quote-notes-grid/quote-notes-grid.component";
import { DateFilter } from "../../../../core/models/common/date-filter-request.dto";
import { InvoicePreviewBillingCommentComponent } from "../invoice-preview-billing-comment/invoice-preview-billing-comment.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { PopoverModule } from "primeng/popover";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { RadioButtonModule } from "primeng/radiobutton";
import { FormsModule } from "@angular/forms";

@UntilDestroy()
@Component({
  selector: "jni-quotes-listing",
  templateUrl: "./quotes-listing.component.html",
  styleUrls: ["./quotes-listing.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    ModalStackerComponent,
    HidedynamicsdatePipe,
    DateFilterComponent,
    InvoicePreviewBillingCommentComponent,
    RadioButtonModule,
    QuoteSummaryComponent,
    QuoteNotesGridComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    PopoverModule,
    SpinnerComponent,
    FormsModule,
  ],
})
export class QuotesListingComponent implements OnInit {
  quoteListings: GetQuotesDto[] = [];
  filterQuoteListings: GetQuotesDto[] = [];
  filteredDataQuoteListingsLists: GetQuotesDto[] = [];
  selectedorderListing: GetQuotesDto[] = [];
  listAfterGridFilter: GetQuotesDto[] = [];
  //ordersfilterList: any[] = [];
  showSmallLoader = false;
  checkboxStatus = 0;
  quoteDisplayModal = false;
  saleOrderId = "";
  copyButtonStatus = false;
  radioButtonStatus = "All";
  invoicePreviewListingModalStatus = false;
  orderNotesDisplayModal = false;
  createdDateColumn = "createdDate";
  inHandDateColumn = "inHandsDateD365";

  orderNotesGridListing: QuotesNotesDto[] = [];

  public orderBilling$ = new Subject<string>();
  menuSelected!: Signal<string>;
  selectedRadioButton = "All";

  constructor(
    private _router: Router,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _createHeaderQuoteService: CreateHeaderQuoteService,
    private _sidebarService: SidebarService,
    private _quoteNotesGridService: QuoteNotesGridService,
    private _sharedService: SharedService
  ) {
    this.menuSelected = this._sidebarService.menu$;
  }

  ngOnInit(): void {
    this.getAllQuote();
    this.getOrderBilling();
    if (this.menuSelected() === "proposal") {
      this.quoteDisplayModal = false;
    }
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  onHoverBillingComments(orderNumber: string, billingComment: string) {
    this.orderNotesGridListing = [];
    if (orderNumber && billingComment) {
      this.orderBilling$.next(orderNumber);
    }
  }

  onOrdersRedirection() {
    this._router.navigate(["proposal/add-header"]);
  }

  getAllQuote() {
    this._loaderService.setLoaderState(true);
    this._createHeaderQuoteService
      .getAllQuotes()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.quoteListings = res.data;
          if (this.quoteListings?.length > 0) {
            this.filterQuoteListings = this.quoteListings;
            this.filteredDataQuoteListingsLists = this.quoteListings;
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  getQuoteOnChange(value: string) {
    if (value === QuoteStatus.Open) {
      this.radioButtonStatus = "Open";
      this.getOpenQuote();
    } else if (value === QuoteStatus.Emailed) {
      this.radioButtonStatus = "Emailed";
      this.getEmailedQuote();
    } else if (value === QuoteStatus.Templete) {
      this.radioButtonStatus = "Templete";
      this.getTempleteQuote();
    } else if (value === QuoteStatus.Accepted) {
      this.radioButtonStatus = "Accepted";
      this.getAcceptedQuote();
    } else if (value === QuoteStatus.All) {
      this.radioButtonStatus = "All";
      this.getAllQuoteData();
    }
  }

  getAllQuoteData() {
    this.filterQuoteListings = this.quoteListings;
    this.filteredDataQuoteListingsLists = this.quoteListings;
  }

  getOpenQuote() {
    const openQuotes = this.quoteListings?.filter(
      x =>
        x?.salesOrderStatusD365?.toLowerCase() === "new" ||
        x?.salesOrderStatusD365?.toLowerCase() === "emailed" ||
        x?.salesOrderStatusD365?.toLowerCase() === "accepted"
    );
    this.filterQuoteListings = openQuotes;
    this.filteredDataQuoteListingsLists = openQuotes;
  }

  getEmailedQuote() {
    const quoteEmailed = this.quoteListings.filter(
      x => x?.salesOrderStatusD365?.toLowerCase() === "emailed"
    );
    this.filterQuoteListings = quoteEmailed;
    this.filteredDataQuoteListingsLists = quoteEmailed;
  }

  getTempleteQuote() {
    const quoteTemplate = this.quoteListings.filter(
      x => x?.type?.toLowerCase() === "template"
    );
    this.filterQuoteListings = quoteTemplate;
    this.filteredDataQuoteListingsLists = quoteTemplate;
  }

  getAcceptedQuote() {
    const quoteAccepted = this.quoteListings.filter(
      x => x?.salesOrderStatusD365?.toLowerCase() === "accepted"
    );
    this.filterQuoteListings = quoteAccepted;
    this.filteredDataQuoteListingsLists = quoteAccepted;
  }

  exportExcel() {
    this.showSmallLoader = true;
    this.exportExcelForFilterData(this.filteredDataQuoteListingsLists);
    this.showSmallLoader = false;
  }

  exportExcelForFilterData(filterclientlist: GetQuotesDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Number"]: datum.salesOrderIdD365,
        ["Status"]: datum.salesOrderStatusD365,
        ["Name"]: datum.customerName,
        ["Job Name"]: datum.jobNameD365,
        ["Buyer"]: datum.buyerD365,
        ["Cust PO"]: datum.customerPONumberD365,
        ["Branding Consultant"]: datum.brandingConsultant,
        ["Created DateTime"]: new Date(datum.createdDate),
        ["Order Subtotal"]: datum.orderSubTotal,
        ["Commission"]: datum.commissionD365,
        ["Gp%"]: datum.grossProfitD365 ?? 0,
        ["Currency"]: datum.foreignCurrencyD365,
        ["In hands"]: new Date(datum.inHandsDateD365 ?? ""),
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ProposalList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  redirectToSummary(saleOrderId: string) {
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.quoteDisplayModal = true;
    }
    //this._router.navigate(['proposal/quote-summary/' + saleOrderId]);
  }

  closeModalForQuote() {
    this.quoteDisplayModal = false;
  }

  onQuoteSelection() {
    if (this.selectedorderListing.length == 1) {
      this.copyButtonStatus = true;
    } else {
      this.copyButtonStatus = false;
    }
  }

  onCopyProposal() {
    if (this.selectedorderListing.length === 1) {
      this._createHeaderQuoteService
        .copyHeaderData(this.selectedorderListing[0]?.salesOrderIdD365 ?? "")
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this._toastr.success("Success", res.message);
              const url = `/proposal/quote-summary/${res.data}`;
              this._router.navigate([url]);
            } else {
              this._toastr.error(
                "Error",
                res.message || "Error copying proposal"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error(
              "Error",
              res.message || "Error copying proposal"
            );
          },
        });
    }
  }

  getOrderBilling() {
    this.orderBilling$
      .pipe(
        debounceTime(200),
        switchMap((orderNumber: string) => {
          if (orderNumber) {
            return this._quoteNotesGridService.getQuoteNotes(orderNumber);
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data) {
            if (res?.data?.length > 0) {
              this.orderNotesGridListing = res.data;
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  orderNotesDisplayModalFunction(status: boolean) {
    this.orderNotesDisplayModal = status;
  }

  closeModalForOrderNotes() {
    this.orderNotesDisplayModal = false;
  }

  addScollHiddenClass() {
    this.orderNotesDisplayModal = false;
  }

  clearFilter(event: GetQuotesDto[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterQuoteListings = event;
    }
  }

  applyFilter(event: GetQuotesDto[] | DateFilter) {
    if (Array.isArray(event)) {
      this.filterQuoteListings = event;
    }
  }

  onFilter(event: TableFilterEvent) {
    if (Object.keys(event.filteredValue).length !== 0) {
      this.filteredDataQuoteListingsLists = event.filteredValue;
    } else {
      this.filteredDataQuoteListingsLists = this.filterQuoteListings;
    }
  }
}
